import React, { PureComponent } from "react";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import {
  convertKeys,
  ToDateDayMonthJalali,
  ToDateJalali,
} from "../../../../Common/Function";
const LineChart = ({ line }) => {
  return (
    <div className="col-md-8 ">
      <div
        style={{
          backgroundColor: "#fff",
          borderRadius: "8px",
          boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
          padding: "10px",
        }}
      >
        <ResponsiveContainer width="100%" aspect={3}>
          <AreaChart
            width={500}
            height={400}
            data={convertKeys(line, { label: "name", value: "uv" })
              .reverse()
              .map(item => {
                return {
                  name: ToDateDayMonthJalali(item.name),
                  فروش: +item.uv,
                };
              })}
            margin={{
              top: 10,
              right: 30,
              left: 0,
              bottom: 0,
            }}
            style={{ direction: "ltr" }}
          >
            <CartesianGrid vertical={false} />
            <XAxis dataKey="name" />
            <YAxis />
            <Tooltip />
            <Area
              type="monotone"
              // unit={"تومان"}
              dataKey="فروش"
              stroke="#307BFF"
              fill="#E6F2FF"
              stackId={"12"}
              strokeWidth="2"
              // activeDot={() => {
              //   return (
              //     <div>
              //       <h3>dawdawd</h3>
              //     </div>
              //   );
              // }}
              activeDot={{ stroke: "#fff", strokeWidth: 8, r: 10, dot: "red" }}
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default LineChart;
